import api from '../index'

const itemService = {
    // List all items
    getItems: async (params) => {
        try {
            const res = await api.get('/api/v1/admin/items', { params })
            return { success: true, data: res.data.data }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Failed to fetch items'
            console.error('API call failed:', error)
            return { success: false, message: errorMessage, error }
        }
    },
    // Get item by ID
    getItemById: (id) => api.get(`/items/${id}`),

    // Create a new item
    createItem: (data) => api.post('/items', data),

    // Update an existing item
    updateItem: async (id, data) => {
        try {
            const res = await api.put(`/api/v1/admin/items/${id}`, { item: data })
            return { success: true, data: res.data.data }
        } catch (error) {
            return { success: false, messages: error.response?.data, error }
        }
    },

    // Delete an item
    deleteItem: (id) => api.delete(`/items/${id}`),

    // Filter items based on query parameters
    filterItems: (query) => api.get('/items', { params: query }),
}

export default itemService
